/**
 * @file  Contact
 * @author yuanyaojia@baijia.com
 * @date 2021-04-21
 */

import React, {useContext} from 'react';
import {Navigation} from '@yunying/crow';
// eslint-disable-next-line import/extensions
import routes from '~/route.config';

import './index.less';

function Contact(props) {
    const {children} = props;

    return (
        <div className="contact-content">
            <Navigation dataSource={
                routes[0].subRoutes.find(item => item.name === 'contact').subRoutes
                    .filter(item => (item.path !== 'unsubscribe'))
                    .map((item, index) => ({
                        title: item.title,
                        key: index,
                        path: `/contact/${item.path}`
                    }))
            }
            />
            {children}
        </div>
    );
}

export default Contact;
